import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { DelegationRule, DelegationRuleCreate, DelegationRuleFilter } from '../data/delegationRule';

export function createDelegationRuleService(client: AxiosInstance) {
  return createCrudService<DelegationRule, DelegationRuleCreate, DelegationRuleFilter>(
    client,
    '/workflow/DelegationRule',
    'id',
  );
}

export type DelegationRuleService = CrudService<DelegationRule, DelegationRuleCreate, DelegationRuleFilter>;
